import { render, staticRenderFns } from "./TicketNotice.vue?vue&type=template&id=16fe931e&scoped=true"
import script from "./TicketNotice.vue?vue&type=script&lang=js"
export * from "./TicketNotice.vue?vue&type=script&lang=js"
import style0 from "./TicketNotice.vue?vue&type=style&index=0&id=16fe931e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fe931e",
  null
  
)

export default component.exports